import { createGlobalState } from '@vueuse/core';
import { ref, computed } from 'vue';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { useDisposes } from '@telecom/shared/composables/use-disposes';
import { EmbodimentClaimFeaturesService } from '../service/embodiment-claim-features-service';
import type { EmbodimentClaimFeaturesState } from '../types';

export const useClaimFeatures = createGlobalState(() => {
    const claimFeaturesService = injectService<EmbodimentClaimFeaturesService>(EmbodimentClaimFeaturesService);

    const { disposes } = useDisposes();

    const modelData = ref<EmbodimentClaimFeaturesState>(claimFeaturesService.getModelData());
    disposes.push(claimFeaturesService.onStateChange(state => modelData.value = state));

    const isLoading = computed(() => modelData.value.isLoading);

    const claimFeatures = computed(() => modelData.value.claimFeatures);

    async function fetchClaimFeatures() {
        await claimFeaturesService.initClaimFeatures();
    }

    return {
        isLoading,
        claimFeatures,
        fetchClaimFeatures,
    };
});
